const buttons = document.querySelectorAll('[data-doto-back-to-top]');

buttons.forEach((button) => {
  if (button.dataset.dotoBackToTopReady === 'true') return;
  button.dataset.dotoBackToTopReady = 'true';

  const showAfter = Number(button.dataset.showAfter || 650);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;

  const update = () => {
    const isVisible = window.scrollY >= showAfter;
    button.classList.toggle('is-visible', isVisible);
    button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reduceMotion.matches ? 'auto' : 'smooth'
    });
  });

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('pageshow', update);
  update();
});
